import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-dialog-peso',
  templateUrl: './dialog-peso.component.html',
  styleUrls: ['./dialog-peso.component.scss']
})
export class DialogPesoComponent implements OnInit {

  pesoMaximoAtingido: boolean = false

  constructor(
    public dialogRef: MatDialogRef<DialogPesoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { agendaSelecionada: any }
  ) { }

  ngOnInit() {
    const userData = sessionStorage.getItem('userData')
    if (!userData) return

    const userDataJson = JSON.parse(userData)
    if (!userDataJson.peso) return

    this.verificarPeso(userDataJson.peso)
    if (!this.pesoMaximoAtingido) this.onConfirmarClick()
  }

  verificarPeso(pesoStrOrEv: number | Event) {
    let pesoCerto: number = 0
    if (typeof pesoStrOrEv !== 'number') {
      const pesoEvent = pesoStrOrEv.target as HTMLInputElement
      pesoCerto = parseFloat(pesoEvent.value)
    } else {
      pesoCerto = parseFloat(pesoStrOrEv.toString())
    }

    const agendasStr = sessionStorage.getItem('agendas')
    if (!agendasStr) return

    const agendas = JSON.parse(agendasStr)
    const foundAgenda = agendas.find((val: any) => val.descricao === this.data.agendaSelecionada)
    if (!foundAgenda) return

    if (pesoCerto > foundAgenda.peso_suportado) {
      this.pesoMaximoAtingido = true
    } else {
      this.pesoMaximoAtingido = false
    }
  }

  onConfirmarClick(): void {
    this.dialogRef.close(true)
  }

  onCancelarClick(): void {
    this.dialogRef.close(false)
  }
}
